// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"a1d210e79c155aeae278","147":"9c33c830f0acfd744fdc","251":"b59f32dd1cbe4a1a1770","352":"e2353faf66d2cfb4d39f","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};